import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const AddStudentToEnrollmentMutation = graphql.persisted(
  "AddStudentToEnrollment",
  graphql(`
    mutation AddStudentToEnrollment($input: AddStudentToEnrollmentInput!) {
      addStudentToEnrollment(input: $input) {
        studentEnrollment {
          id
          state
          enrollmentKind
          gradeLevel
          needsReview
          familyEnrollment {
            id
            state
            enrollmentKind
            family {
              id
              name
              slug
            }
          }
        }
        familyEnrollment {
          id
          state
          enrollmentKind
          inviteStatus
          studentCount
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { AddStudentToEnrollmentMutation };

export function useAddStudentToEnrollmentMutation() {
  return useMutation(AddStudentToEnrollmentMutation);
}
